export default function applyConditionalClasses (element, classes) {
  for (let [className, condition] of Object.entries(classes)) {
    element.classList[condition ? 'add' : 'remove'](className);
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-apply-conditional-classes.js